module.exports = __webpack_public_path__ + "media/images/badge/tattico_secondary-f06409e5ce99538b893903c65ee5ff8e.png";